import { MOD_LABELS } from "@/domain/modifiers/labels";

/**
 * A held combo ("Ctrl+Shift") rendered as its modifier kbd-pills - the one presentation shared by the
 * bindings list, the changes list, and the readout. Renders nothing for an empty/absent combo, so a
 * caller can drop it in unconditionally. `className` is the per-pill class ("mod" by default; the
 * readout passes "" because its parent .mono span styles the pills).
 */
export function ComboKbds({ combo, className = "mod" }: { combo?: string; className?: string }) {
  if (!combo) return null;
  return (
    <>
      {combo.split("+").map((m) => (
        <kbd key={m} className={className || undefined}>
          {MOD_LABELS[m] ?? m}
        </kbd>
      ))}
    </>
  );
}
